/**
 * Copyright 2015-present Isshoikka. All Rights Reserved.
 *
 */

const IsshoikkaInitializerActionConstants = {
    LOAD_ALL: "read_all",
    LOAD_ALL_FONTS: "load_all_fonts",
    LOAD_MASK: "load_mask",
};

export default IsshoikkaInitializerActionConstants;
